import { render, staticRenderFns } from "./shop-compensate-summary-component.vue?vue&type=template&id=40cad35e&scoped=true&"
import script from "./shop-compensate-summary-component.vue?vue&type=script&lang=js&"
export * from "./shop-compensate-summary-component.vue?vue&type=script&lang=js&"
import style0 from "./shop-compensate-summary-component.vue?vue&type=style&index=0&id=40cad35e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cad35e",
  null
  
)

export default component.exports